import { createContext } from 'react';
export const EntityDisplayStateContext = createContext({
    defaultContextValue: true,
});
EntityDisplayStateContext.displayName = 'EntityDisplayStateContext';
//# sourceMappingURL=EntityDisplayStateContext.js.map